export interface ShareInput {
  title: string;
  url: string;
  text?: string;
}

export type ShareResult =
  | { kind: 'shared' }
  | { kind: 'copied' }
  | { kind: 'cancelled' }
  | { kind: 'error'; message: string };

export async function shareOrCopy(input: ShareInput): Promise<ShareResult> {
  if (typeof navigator !== 'undefined' && 'share' in navigator) {
    try {
      await (navigator as Navigator & { share: (i: ShareInput) => Promise<void> }).share(input);
      return { kind: 'shared' };
    } catch (err: unknown) {
      const name = (err as DOMException | undefined)?.name ?? '';
      if (name === 'AbortError') return { kind: 'cancelled' };
      // Fall through to clipboard if share fails for non-cancellation reasons.
    }
  }
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(input.url);
      return { kind: 'copied' };
    }
  } catch (err) {
    return {
      kind: 'error',
      message: err instanceof Error ? err.message : 'Clipboard unavailable',
    };
  }
  return { kind: 'error', message: 'Sharing unsupported in this browser' };
}
